import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Label = ({
	className,
	...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) => (
	<LabelPrimitive.Root
		data-slot="label"
		className={cn(
			'text-[11px] font-medium uppercase tracking-[0.12em] text-[var(--muted-gallery)] peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
			className,
		)}
		{...props}
	/>
)

export { Label }
